import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { IdDocumentScanComponent } from "./id-document-scan.component";

/**
 * The scanner is used from several feature areas, and AddLeadModule here is its
 * own NgModule - a component can only be declared once, so it is declared and
 * exported from this module rather than from AppModule.
 */
@NgModule({
  declarations: [IdDocumentScanComponent],
  imports: [CommonModule],
  exports: [IdDocumentScanComponent]
})
export class IdDocumentScanModule {}



// WEBPACK FOOTER //
// ./src/app/shared/components/id-document-scan/id-document-scan.module.ts